import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { UserLocationService } from 'src/app/@shared/services/user-location/user-location.service';
import { FAVORITE_ADDRESSES, LAST_SEARCHES, MY_LOCATION, SEARCH_ON_MAP } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { FavoriteAddresses } from 'src/app/modules/route-planner/interfaces/favorites/favorite-addresses.interface';
import { Address } from 'src/app/modules/route-planner/interfaces/location/address.interface';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';

@Component({
    selector: 'app-address-auto-complete-feed',
    templateUrl: './address-auto-complete-feed.component.html',
    styleUrls: ['./address-auto-complete-feed.component.scss'],
    standalone: false
})
export class AddressAutoCompleteFeedComponent implements OnInit {
  @Output() onLastSearchClick = new EventEmitter<Address>();
  @Output() onHomeClick = new EventEmitter<Address>();
  @Output() onWorkClick = new EventEmitter<Address>();
  @Output() onMapClick = new EventEmitter<void>();
  @Output() onCurrentLocationClick = new EventEmitter<void>();

  @Input() favoriteAddresses: FavoriteAddresses;
  @Input() isCurrentLocationLoading: boolean = false;
  @Input() hideCurrentLocation: boolean = false;

  searchOnMapEnabled: boolean = true;

  myLocationText: string
  searchOnMapText: string
  favoriteAddressesText: string
  lastSearchesText: string
  hasLocationPermissions: boolean = !!this.userLocationService.hasPermissions;
  

  constructor(
    private readonly userLocationService: UserLocationService,
    private readonly languageService: LanguageService,
    private readonly routePlanningService: RoutePlanningService,
    private readonly resizeService: ResizeService,
  ) { }

  ngOnInit(): void {
    this.initializeMultiLanguageTexts();
    this.routePlanningService._mapOverlaySub.subscribe(
      (mapObj) => (this.searchOnMapEnabled = !mapObj)
    );

    // Check if browser supports geolocation
    this.hasLocationPermissions =
      'geolocation' in navigator && this.userLocationService.hasPermissions;

    // For first-time users who haven't made a choice yet, update UI when permission changes
    // But don't prompt automatically
    if ('geolocation' in navigator) {
      // Use the silent check that doesn't show popups
      this.userLocationService.checkPermissionsSilently().subscribe((hasPermissions) => {
        this.hasLocationPermissions = hasPermissions;
      });
    }
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.myLocationText = MY_LOCATION[language.language]
      this.searchOnMapText = SEARCH_ON_MAP[language.language]
      this.favoriteAddressesText = FAVORITE_ADDRESSES[language.language]
      this.lastSearchesText = LAST_SEARCHES[language.language]
    })
  }

  isInMobileView() {
    return this.resizeService.isMobile;
  }
}
